import { useEffect, useRef, useState } from 'react';

const conciergesChip = {
    marginLeft: '8px',
    backgroundColor: '#e8e8e8',
    color: '#555',
    padding: '2px 10px',
    borderRadius: '12px',
    fontSize: '1.1rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    display: 'inline-block'
};

export default function DesignateAgentModal({ isOpen, csr, allApiProducers, onClose, onAssign }) {
    const modalRef = useRef();
    const [selectedProducerId, setSelectedProducerId] = useState('');

    useEffect(() => {
        if (!modalRef.current) return;
        if (isOpen) {
            modalRef.current.setAttribute('open', '');
        } else {
            modalRef.current.removeAttribute('open');
        }

        const modal = modalRef.current;
        const handleModalClosed = () => {
            setSelectedProducerId('');
            onClose();
        };
        modal.addEventListener('modal-closed', handleModalClosed);
        return () => modal.removeEventListener('modal-closed', handleModalClosed);
    }, [isOpen, onClose]);

    // Pre-populate with current supervisor when modal opens
    useEffect(() => {
        if (!csr || !isOpen) return;
        const currentProducer = allApiProducers.find(p => {
            const name = `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim();
            return name === csr.supervisingAgent;
        });
        setSelectedProducerId(currentProducer?.agentSob ?? '');
    }, [csr, isOpen, allApiProducers]);

    const handleClose = () => {
        setSelectedProducerId('');
        onClose();
    };

    const handleAssign = () => {
        if (!selectedProducerId) return;
        onAssign(selectedProducerId);
        setSelectedProducerId('');
    };

    return (
        <gds-modal type="modal" ref={modalRef}>
            <span slot="header">Designate Supervising Licensed Agent</span>
            <div>
                {csr && (
                    <div style={{
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '12px 16px',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '10px',
                        backgroundColor: '#fafafa'
                    }}>
                        <span style={{ fontWeight: '600' }}>
                            Producer: <span style={{ fontWeight: '400' }}>{csr.name}</span>
                        </span>
                        <span style={{ color: '#ccc' }}>|</span>
                        <span style={conciergesChip}>Concierges</span>
                    </div>
                )}
                <div style={{ marginBottom: '8px', width: '100%' }}>
                    <label
                        htmlFor="designate-supervisor-select"
                        style={{ fontWeight: '700', fontSize: '1.3rem', display: 'block', marginBottom: '6px' }}
                    >
                        Search Licensed Producers
                    </label>
                    <gds-input-wrapper size="large" style={{ display: 'block', width: '100%' }}>
                        <gds-icon slot="left-visual" icon-type="search" size="small" />
                        <select
                            slot="input"
                            id="designate-supervisor-select"
                            name="designate-supervisor-select"
                            value={selectedProducerId}
                            onChange={e => setSelectedProducerId(e.target.value)}
                            style={{ width: '100%', border: 'none', outline: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <option value="">Please Select</option>
                            {allApiProducers.map(p => (
                                <option key={p.agentSob} value={p.agentSob}>
                                    {p.firstName} {p.lastName} NPN {p.npn}
                                </option>
                            ))}
                        </select>
                    </gds-input-wrapper>
                </div>
            </div>
            <gds-button appearance="secondary" size="large" slot="buttons" type="button" onClick={handleClose}>
                Cancel
            </gds-button>
            <gds-button
                appearance="primary"
                size="large"
                slot="buttons"
                type="button"
                disabled={!selectedProducerId || undefined}
                onClick={handleAssign}
            >
                Assign Agent
            </gds-button>
        </gds-modal>
    );
}
